// extracted by mini-css-extract-plugin
export default {"Menu":"CGSPqIjB","isVisible":"JtWbqd9y"};